import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

interface item {
  value: string;
  label: string;
}

@Component({
  selector: 'app-multi-selection',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './multi-selection.component.html',
  styleUrl: './multi-selection.component.css',
})
export class MultiSelectionComponent implements OnChanges {
  @Input() label = 'Multi selection';
  @Input() itemsArray: item[] = [];
  @Input() itemsFromUrl: string[] | null = null;

  isOpen = false;
  searchControl = new FormControl('');

  @Output() itemsSelectedChange = new EventEmitter<item[]>();
  itemsSelected: item[] | null = null;

  ngOnChanges() {
    this.initialiseItemsSelected();
  }

  initialiseItemsSelected() {
    if (this.itemsFromUrl !== null) {
      if (Array.isArray(this.itemsFromUrl)) {
        this.itemsSelected = this.itemsArray!.filter((item) => this.itemsFromUrl!.includes(item.value));
      } else {
        this.itemsSelected = this.itemsArray!.filter((item) => item.value === this.itemsFromUrl![0]);
      }
    }
  }

  onRemoveSelection(value: string) {
    if (this.itemsSelected === null) return;
    this.itemsSelected = this.itemsSelected.filter((item: item) => item.value !== value);
    return this.itemsSelectedChange.emit(this.itemsSelected);
  }

  onAddItemToSelection(item: item) {
    if (this.itemsSelected === null) {
      this.itemsSelected = [];
    }
    this.itemsSelected.push(item);
    this.searchControl.setValue('');
    this.isOpen = false;
    return this.itemsSelectedChange.emit(this.itemsSelected);
  }

  get availableItems(): item[] {
    if (!this.itemsArray || !this.itemsSelected) return this.itemsArray;
    return this.itemsArray.filter((item) => !this.itemsSelected?.some((selected) => selected.value === item.value));
  }

  get filteredItems(): item[] {
    const term = (this.searchControl.value || '').toLowerCase();
    if (!term) return this.availableItems;
    return this.availableItems.filter((item) => item.label.toLowerCase().includes(term));
  }
}
